import {BaseFacade} from '../../../../../core/abstracts/base-facade.abstract';
import {BehaviorSubject, Subject} from 'rxjs';
import {KeyNumberService} from '../../../key-number/service/key-number.service';
import {VehicleAvailableKeyNumberResponse} from '../../../key-number/model/vehicle-available-key-number.response';
import {ResponseError} from '../../../../../core/models/response-error.model';
import {Injectable} from '@angular/core';
import {VehicleAvailableKeysResponseMapper} from '../mapper/vehicle-available-keys-response.mapper';
import {VehicleAvailableKeys} from '../model/vehicle-available-keys.model';

@Injectable({providedIn: 'root'})
export class KeyNumberFacade extends BaseFacade {

  private readonly availableKeyNumbersSubject: BehaviorSubject<VehicleAvailableKeys[]> = new BehaviorSubject<VehicleAvailableKeys[]>([]);
  readonly availableKeyNumbers$ = this.availableKeyNumbersSubject.asObservable();

  private readonly errorSubject = new Subject<ResponseError | null>();
  readonly error$ = this.errorSubject.asObservable();

  constructor(
    private readonly keyNumberService: KeyNumberService,
    private readonly vehicleAvailableKeysResponseMapper: VehicleAvailableKeysResponseMapper,
  ) {
    super();
  }

  public fetchAvailableKeyNumbers(storageId: number): void {
    this.startLoading();

    this.keyNumberService.getAll(storageId).subscribe({
      next: (result: VehicleAvailableKeyNumberResponse[]) => {
        const availableKeyNumbers: VehicleAvailableKeys[] = this.vehicleAvailableKeysResponseMapper.mapArray(result);

        this.availableKeyNumbersSubject.next(availableKeyNumbers)
      },
      error: (error) => {
        this.errorSubject.next(error);
      },
      complete: () => this.stopLoading()
    });
  }
}
